import { Box } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { StoreDetailsLayout } from '~/components/routes/stores/StoreDetailsLayout'
import { PastInventoriesTab } from '~/components/routes/stores/inventories/PastInventoriesTab'
import { STORE_TAB_PERMISSIONS } from '~/components/routes/stores/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/stores/$storeId/inventories/')({
  staticData: {
    permission: STORE_TAB_PERMISSIONS.inventories,
  },
  component: StorePastInventoriesTab,
  params: {
    parse: z.object({ storeId: z.coerce.number() }).parse,
  },
})
withRoutePermissions(Route)

function StorePastInventoriesTab() {
  const { storeId } = Route.useParams()

  return (
    <StoreDetailsLayout storeId={storeId} tab="inventories">
      <Box sx={{ marginTop: '16px' }}>
        <PastInventoriesTab shopId={storeId} />
      </Box>
    </StoreDetailsLayout>
  )
}
